import type { ReactNode } from "react";

import styles from "./EulaMarkdown.module.css";

function renderBlock(block: string, index: number): ReactNode {
  const trimmed = block.trim();
  if (!trimmed) return null;

  if (trimmed.startsWith("# ")) {
    return (
      <h1 key={index} className={styles.h1}>
        {trimmed.slice(2)}
      </h1>
    );
  }

  if (trimmed.startsWith("## ")) {
    return (
      <h2 key={index} className={styles.h2}>
        {trimmed.slice(3)}
      </h2>
    );
  }

  const lines = trimmed.split("\n");
  if (lines.every((line) => line.startsWith("- "))) {
    return (
      <ul key={index} className={styles.list}>
        {lines.map((line) => (
          <li key={line}>{line.slice(2)}</li>
        ))}
      </ul>
    );
  }

  return (
    <p key={index} className={styles.paragraph}>
      {lines.join(" ")}
    </p>
  );
}

export function EulaMarkdown({ markdown }: { markdown: string }) {
  const blocks = markdown.split(/\n\n+/u);

  return (
    <div className={styles.root}>
      {blocks.map((block, index) => renderBlock(block, index))}
    </div>
  );
}
